// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconInformation = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M14.25 17.25h-.75c-1.24 0-2.25-1.01-2.25-2.25v-3.75h-.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.75c.83 0 1.5.67 1.5 1.5V15c0 .41.34.75.75.75h.75c.41 0 .75.34.75.75s-.34.75-.75.75zm-1.5-10.12c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12 0 .62.5 1.12 1.12 1.12.62 0 1.12-.5 1.12-1.12zM24 12c0-6.62-5.38-12-12-12S0 5.38 0 12s5.38 12 12 12 12-5.38 12-12zm-1.5 0c0 5.79-4.71 10.5-10.5 10.5S1.5 17.79 1.5 12 6.21 1.5 12 1.5 22.5 6.21 22.5 12z"
      fill="currentColor"
    />
  );
export default SvgIconInformation;
